import {
    LOAD_WEATHER_CONDITIONS_START,
    LOAD_WEATHER_CONDITIONS_SUCCESS,
    LOAD_WEATHER_CONDITIONS_FAILURE,
} from './actions';

const initialState = {
    weatherConditions: [],
    constants: {
        qualifierOptions: [],
        timeframeOptions: [],
        valueOptions: [],
        maxNumberOfConditions: 3,
        VALID_WEATHER_CONDITION_MULTIPLE_OPTION_TYPE: [],
        VALID_WEATHER_CONDITION_QUALIFIER: [],
        VALID_WEATHER_CONDITION_TYPE: [],
        VALID_WEATHER_CONDITION_TIMEFRAME: [],
        inputAdornmentMap: {},
    },
    environment: 'ca',
    loading: false,
    error: null,
};

function weatherConditionsReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_WEATHER_CONDITIONS_START:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case LOAD_WEATHER_CONDITIONS_SUCCESS:
            return {
                ...state,
                weatherConditions: action.payload.weatherConditions,
                constants: action.payload.constants,
                environment: action.payload.environment,
                loading: false,
                error: null,
            };

        case LOAD_WEATHER_CONDITIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
}

// Export with the structure expected by root-reducer.js
export const NAME = 'weatherConditions';
export default weatherConditionsReducer;
